<template>
  <div class="slider_box">
    <!-- 轨道 -->
    <div class="slider_track" ref="track" @mousedown="onTrackClick">
      <div class="slider_default"></div>
      <!-- 拖拽点 -->
      <div
        class="slider_thumb"
        :style="{ left: percent }"
        @mousedown.stop="startDrag"
      >
        <div class="slider_thumb_con" />
      </div>
    </div>

    <!-- 刻度 -->
    <div class="slider_steps">
      <span
        v-for="step in steps"
        :key="step"
        :style="{ left: getStepPercent(step) }"
        @click="snapTo(step)"
      >
        {{ step }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyDiscreteSlider",

  props: {
    value: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [0, 50, 60, 85, 100],
    },
    max: {
      type: Number,
      default: 100,
    },
  },

  data() {
    return {
      dragging: false,
      current: this.value,
      timeoutId: null,
    };
  },

  computed: {
    percent() {
      // 线性映射：0%对应0，100%对应max
      if (this.current === 0) {
        return "5px";
      } else if (this.current === 100) {
        return "calc(100% - 10px)";
      } else if (this.current === 85) {
        return "76%";
      } else if (this.current === 50) {
        return "44%";
      } else if (this.current === 60) {
        return "58%";
      } else {
        return (this.current / this.max) * 100 + "%";
      }
    },
  },

  watch: {
    value(val) {
      this.current = val;
    },
  },

  mounted() {
    document.addEventListener("mousemove", this.onDrag);
    document.addEventListener("mouseup", this.stopDrag);
    this.snapTo(this.current);
  },

  beforeDestroy() {
    document.removeEventListener("mousemove", this.onDrag);
    document.removeEventListener("mouseup", this.stopDrag);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  },

  methods: {
    startDrag() {
      this.dragging = true;
    },

    stopDrag() {
      this.dragging = false;
    },

    onDrag(e) {
      if (!this.dragging) return;

      const rect = this.$refs.track.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const ratio = Math.max(0, Math.min(x / rect.width, 1));

      // 线性映射：ratio对应0-100%
      const rawValue = ratio * this.max;
      this.snapTo(rawValue);
    },

    onTrackClick(e) {
      const rect = this.$refs.track.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const ratio = Math.max(0, Math.min(x / rect.width, 1));

      // 线性映射：ratio对应0-100%
      const rawValue = ratio * this.max;
      this.snapTo(rawValue);
    },

    snapTo(val) {
      // 吸附到最近刻度
      const nearest = this.steps.reduce((prev, curr) =>
        Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev,
      );

      this.current = nearest;
      if (this.timeoutId) clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.$emit("changeRuler", nearest);
      }, 300);
    },

    getStepPercent(step) {
      // 线性映射：step对应0-100%
      if (step === 0) {
        return "10px";
      } else if (step === 100) {
        return "calc(100% - 22px)";
      } else if (step === 85) {
        // 为85%刻度调整位置，增加与100%的距离
        return "76%";
      } else if (step === 50) {
        return "44%";
      } else if (step === 60) {
        return "58%";
      } else {
        return (step / this.max) * 100 + "%";
      }
    },
  },
};
</script>

<style scoped>
.slider_box {
  width: 100%;
  height: 55px;
  user-select: none;
  position: relative;
}

.slider_track {
  cursor: pointer;
  width: 100%;
  border-radius: 5px;
  padding: 4px 0;
  position: relative;
}
.slider_default {
  width: 100%;
  height: 100%;
  height: 6px;
  background: #dddddd;
  border-radius: 5px;
}
.slider_progress {
  position: absolute;
  height: 100%;
  height: 6px;
  background: #8e86dd;
  border-radius: 5px;
}

.slider_thumb {
  position: absolute;
  top: 50%;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%);
  background: #8e86dd;
  cursor: pointer;
}

.slider_thumb_con {
  position: absolute;
  top: 50%;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  transform: translate(calc(-50% + 5px), -50%);
  background: #fff;
}
.slider_steps {
  position: relative;
  height: 20px;
  font-size: 14px;
  color: #1a2332;
  line-height: 26px;
  text-align: center;
}

.slider_steps span {
  position: absolute;
  cursor: pointer;
  transform: translateX(-50%);
  white-space: nowrap;
}
@media screen and (max-width: 1920px) {
  .slider_box {
    height: 45px;
  }
}
@media screen and (max-width: 1439px) {
  .slider_box {
    height: 40px;
  }
}
</style>
